export const MANUAL_MOVIE_URL =
  'https://cmcos-manual.s3.ap-northeast-1.amazonaws.com/CMCOS%E8%AA%AC%E6%98%8E%E5%8B%95%E7%94%BB250818.mp4';
